import { Copyright } from "~/screens/Scheduling/InitialVisit/components/Copyright";
import { useBreakpoint } from "~/shared";
import { tw } from "~/utils";

export const VisitFooter = () => {
  const { isMobile } = useBreakpoint();

  return (
    <footer className={tw(!isMobile && "absolute bottom-2 right-40")}>
      <Copyright />
    </footer>
  );
};
